var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 13.5V28C29 30.2 27.2 32 25 32H17.7C16.62 32 15.6 31.57 14.85 30.81L7 22.83C7 22.83 8.26 21.6 8.3 21.58C8.52 21.39 8.79 21.29 9.09 21.29C9.31 21.29 9.51 21.35 9.69 21.45C9.73 21.46 14 23.91 14 23.91V12C14 11.17 14.67 10.5 15.5 10.5C16.33 10.5 17 11.17 17 12V19H18V9.5C18 8.67 18.67 8 19.5 8C20.33 8 21 8.67 21 9.5V19H22V10.5C22 9.67 22.67 9 23.5 9C24.33 9 25 9.67 25 10.5V19H26V13.5C26 12.67 26.67 12 27.5 12C28.33 12 29 12.67 29 13.5Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessHand);
export default __webpack_public_path__ + "static/media/accessHand.fa325e05f21b0bde47076a5a156a8e78.svg";
export { ForwardRef as ReactComponent };